import { IPoint, ISize, Point, Size } from "../../../../base/domain/drawing";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IFormatSpecification } from "../IFormatSpecification";
import { IRectangleCoordinatableObject } from "../objects";
import { AbstractFormatObjectEditor } from "../AbstractFormatObjectEditor";
import { IRectangleCoordinateEditable } from "../properties";

export abstract class AbstractRectangleCoordinatableObjectEditor<TObject extends IRectangleCoordinatableObject> extends AbstractFormatObjectEditor<TObject> implements IRectangleCoordinateEditable {
  constructor(source: TObject | AbstractRectangleCoordinatableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._location = this.createPropertyEditor(s => s.location, (s, v) => s.location = Point.to(Point.from(v).floor()));
    this._size = this.createPropertyEditor(s => s.size, (s, v) => s.size = Size.to(Size.from(v).floor()));
    this._center = this.createPropertyEditor(
      s => Point.to(Point.from(s.location).add(Size.from(s.size).multiply(0.5).toPoint()).floor()),
      (s, v) => s.location = Point.to(Point.from(v).subtract(Size.from(s.size).multiply(0.5).toPoint()).floor()));
    this._bottomRight = this.createPropertyEditor(
      s => Point.to(Point.from(s.location).add(Size.from(s.size).toPoint()).floor()),
      (s, v) => s.location = Point.to(Point.from(v).subtract(Size.from(s.size).toPoint()).floor()));
  }

  protected _location: IPropertyEditable<IPoint>;
  protected _size: IPropertyEditable<ISize>;
  protected _center: IPropertyEditable<IPoint>;
  protected _bottomRight: IPropertyEditable<IPoint>;

  location(): IPropertyEditable<IPoint> {
    return this._location;
  }

  size(): IPropertyEditable<ISize> {
    return this._size;
  }

  topLeft(): IPropertyEditable<IPoint> {
    return this._location;
  }

  center(): IPropertyEditable<IPoint> {
    return this._center;
  }

  bottomRight(): IPropertyEditable<IPoint> {
    return this._bottomRight;
  }

  getOverview(): string {
    const location = this.location().getValue();
    const size = this.size().getValue();
    return this.getIdentifierOverview()
      + " (" + location.x + "," + location.y + ") "
      + size.width + "x" + size.height;
  }
}
